export const getPythonTemplate = (
  publisherId: string,
  publisherName: string,
  config: any
) => {
  const date = new Date().toISOString().split('T')[0];
  
  // Extract config values
  const placementMode = config.mode || 'after';
  const hasInlineConfig = placementMode === 'inline' && config.inline_config;
  
  // Generate inline config if needed
  let inlineConfigCode = '';
  if (hasInlineConfig) {
    const inlineConfig = config.inline_config;
    inlineConfigCode = `
    inline_config=InlineConfig(
        max_insertions=${inlineConfig.max_insertions || 1},
        insertion_strategy="${inlineConfig.insertion_strategy || 'discourse'}",
        blend_style="${inlineConfig.blending_style === 'conversational' ? 'soft' : 
                      inlineConfig.blending_style === 'distinct' ? 'direct' : 'soft'}",
        insert_after_paragraphs=${inlineConfig.insert_after_paragraphs || 1}${inlineConfig.tone_matching ? ',\n        tone_matching=True' : ''}${inlineConfig.skip_on_factual ? ',\n        skip_on_factual=True' : ''}
    )`;
  }
  
  // Generate response format preference if specified
  const responseFormatCode = config.response_format && config.response_format !== 'auto' 
    ? `\n    response_format_preference="${config.response_format === 'text' ? 'plain' : config.response_format}",` 
    : '';
  
  return `# Generated configuration for publisher: ${publisherName}
# Publisher ID: ${publisherId}
# Generated on: ${date}

from llm_ads.middleware import AdServingMiddleware
from llm_ads.config import AdServingConfig${hasInlineConfig ? ', InlineConfig' : ''}

# Your configuration based on selected settings
config = AdServingConfig(
    publisher_id="${publisherId}",  # Your Reasonic Publisher ID
    ad_placement_mode="${placementMode}",${responseFormatCode}${hasInlineConfig ? inlineConfigCode : ''}
)

# Implementation example for FastAPI:
app.add_middleware(
    AdServingMiddleware,
    config=config
)

# Implementation example for Flask:
# from llm_ads.flask import ad_serving_middleware
# app = ad_serving_middleware(app, config)
`;
}; 